import { ListChecks, Scale } from 'lucide-react';
import { Breadcrumb } from '../../../../components/Breadcrumb';
import { SettingsMenu, type SettingsMenuEntry } from '../../../../components/settings/SettingsMenu';
import { APPLICANT_REQUIREMENTS_PATH, SCORE_POINTS_PATH } from '../recruitmentPaths';

/*
  What Recruitment configures — one row per surface, each leading to its own page. The route and the
  sidebar entry carry ANY of the rows' keys, as `anyOf`; a row added owes its key to both in the
  same change.
*/
const ENTRIES: SettingsMenuEntry[] = [
  {
    key: 'applicant-requirements',
    label: 'Applicant Requirements',
    description: 'What an applicant is expected to submit — the checklist used at initial screening.',
    icon: ListChecks,
    to: APPLICANT_REQUIREMENTS_PATH,
    permission: 'applicant-requirements.read',
  },
  {
    key: 'score-points',
    label: 'Score Points',
    description: 'The weight each assessment stage carries in an applicant’s Summary.',
    icon: Scale,
    to: SCORE_POINTS_PATH,
    permission: 'applicants.read',
  },
];

/**
 * Recruitment → Settings: a **menu of what the group configures**, not the settings themselves.
 * Each row leads to a full page.
 */
export function RecruitmentSettingsPage() {
  return (
    <div className="flex h-full min-h-0 min-w-0 flex-col bg-slate-50">
      <Breadcrumb segments={['Human Resources', 'Recruitment', 'Settings']} />

      <div className="modern-scrollbar min-h-0 flex-1 overflow-auto p-4">
        <div className="mx-auto flex max-w-3xl flex-col gap-3">
          <p className="text-xs text-slate-500">
            The vocabulary Vacancies and Applicants draw on. The postings and applicants themselves are on their own
            pages.
          </p>

          <SettingsMenu entries={ENTRIES} />
        </div>
      </div>
    </div>
  );
}
